import SignupFormAuth from '../components/SignupFormAuth';

export default function SignupPageAuth() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', minHeight: '100vh', padding: '260px 0 0 60px', maxWidth: 400 }}>
      <SignupFormAuth />
    </div>
  );
}
